import type { ComponentProps } from "react";
import { CredentialVaultPanel } from "@/features/credentials/components/credential-vault-panel";

export function ProfileCredentialsPanel(
  props: ComponentProps<typeof CredentialVaultPanel>,
) {
  return <CredentialVaultPanel {...props} />;
}
